import { render, staticRenderFns } from "./SpendingEvolution.vue?vue&type=template&id=34de6ea4&"
import script from "./SpendingEvolution.vue?vue&type=script&lang=js&"
export * from "./SpendingEvolution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports